/******/ (function() { // webpackBootstrap
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Section: Hero Video
 * ------------------------------------------------------------------------------
 * This will allow for playing and pausing native hero video
 *
 * @namespace HeroBanner
 */
var HeroBanner = /*#__PURE__*/function () {
  function HeroBanner(element) {
    _classCallCheck(this, HeroBanner);
    this.element = element;
    this.desktopVideo = this.element.querySelector('.hero-banner__video-desktop [jsVideoHero="video"]');
    this.mobileVideo = this.element.querySelector('.hero-banner__video-mobile [jsVideoHero="video"]');
    this.fallbackVideo = this.element.querySelector('.hero-banner__video-native:not(.hero-banner__video-desktop):not(.hero-banner__video-mobile) [jsVideoHero="video"]');
    this.playPauseBtn = this.element.querySelector('#playPauseBtn');
    if ((this.desktopVideo || this.mobileVideo || this.fallbackVideo) && this.playPauseBtn) {
      this.init();
    }
  }
  return _createClass(HeroBanner, [{
    key: "init",
    value: function init() {
      this.playPauseBtn.querySelector('.icon__circle-pause').classList.add('icon__circle-pause--active');
      this.playPauseBtn.addEventListener('click', this.togglePlayPause.bind(this));

      // Handle window resize to sync video states
      window.addEventListener('resize', this.handleResize.bind(this));
    }
  }, {
    key: "getCurrentVideo",
    value: function getCurrentVideo() {
      // Check which video is currently visible based on screen size
      if (window.innerWidth >= 769) {
        return this.desktopVideo || this.fallbackVideo;
      } else {
        return this.mobileVideo || this.fallbackVideo;
      }
    }
  }, {
    key: "syncVideoStates",
    value: function syncVideoStates() {
      var currentVideo = this.getCurrentVideo();
      var otherVideos = [this.desktopVideo, this.mobileVideo, this.fallbackVideo].filter(function (video) {
        return video && video !== currentVideo;
      });
      if (currentVideo) {
        // Sync play state from other videos
        var shouldBePlaying = otherVideos.some(function (video) {
          return video && !video.paused;
        });
        if (shouldBePlaying && currentVideo.paused) {
          currentVideo.play();
        } else if (!shouldBePlaying && !currentVideo.paused) {
          currentVideo.pause();
        }

        // Update UI based on current video state
        this.updatePlayPauseUI(currentVideo.paused);
      }
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      var _this = this;
      // Debounce resize events
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(function () {
        _this.syncVideoStates();
      }, 100);
    }
  }, {
    key: "updatePlayPauseUI",
    value: function updatePlayPauseUI(isPaused) {
      var playIcon = this.playPauseBtn.querySelector('.icon__circle-play');
      var pauseIcon = this.playPauseBtn.querySelector('.icon__circle-pause');
      if (isPaused) {
        playIcon.classList.add('icon__circle-play--active');
        pauseIcon.classList.remove('icon__circle-pause--active');
      } else {
        playIcon.classList.remove('icon__circle-play--active');
        pauseIcon.classList.add('icon__circle-pause--active');
      }
    }
  }, {
    key: "togglePlayPause",
    value: function togglePlayPause() {
      var currentVideo = this.getCurrentVideo();
      if (!currentVideo) return;
      if (currentVideo.paused) {
        // Play current video and pause others
        currentVideo.play();
        [this.desktopVideo, this.mobileVideo, this.fallbackVideo].filter(function (video) {
          return video && video !== currentVideo;
        }).forEach(function (video) {
          return video.pause();
        });
        this.updatePlayPauseUI(false);
      } else {
        // Pause all videos
        [this.desktopVideo, this.mobileVideo, this.fallbackVideo].filter(function (video) {
          return video;
        }).forEach(function (video) {
          return video.pause();
        });
        this.updatePlayPauseUI(true);
      }
    }
  }]);
}(); // Initialize HeroBanner instances
function initHeroBanners() {
  document.querySelectorAll('[data-section-type="hero-banner"]').forEach(function (banner) {
    if (!banner.heroBannerInstance) {
      banner.heroBannerInstance = new HeroBanner(banner);
    }
  });
}

// Handle Shopify section events
document.addEventListener('shopify:section:load', function (event) {
  if (event.target.querySelector('[data-section-type="hero-banner"]')) {
    initHeroBanners();
  }
});

// Initialize on page load
document.addEventListener('DOMContentLoaded', initHeroBanners);
/******/ })()
;